import { render, staticRenderFns } from "./NationList.vue?vue&type=template&id=726dd71c&scoped=true"
import script from "./NationList.vue?vue&type=script&lang=js"
export * from "./NationList.vue?vue&type=script&lang=js"
import style0 from "./NationList.vue?vue&type=style&index=0&id=726dd71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726dd71c",
  null
  
)

export default component.exports